import { MissionCondition } from "../types/mission.type";

export type RequirementDraft = Omit<MissionCondition, "id">;

export const EMPTY_REQUIREMENT_DRAFT: RequirementDraft = {
  condition_group_label: "general",
  type_label: "",
  value_label: "",
  provider_klass: "",
};
